import { createModule } from '../../createModule';
import { appendFiles } from '../../shared';
export const createDataUploadAPI = createModule(({ http }) => {
    return {
        getFundsMetadata: async (params) => {
            const res = await http.get('/v2/data-upload/funds-metadata', {
                params,
            });
            return res;
        },
        uploadData: async (body) => {
            const formData = new FormData();
            formData.append('value_date', body.value_date);
            if (body.liquidity_report) {
                appendFiles(formData, 'liquidity_report', body.liquidity_report);
            }
            if (body.rating) {
                appendFiles(formData, 'rating', body.rating);
            }
            const res = await http.post('/v2/data-upload/upload', {
                body: formData,
            });
            return res;
        },
        updateFundsMetadata: async (body) => {
            const res = await http.patch('/v2/data-upload/funds-metadata', { body: body });
            return res;
        },
    };
});
